import { type FC } from 'react'
import { WelcomeIraPage } from '../v2/welcome-ira'

export const WelcomeWrapper: FC = () => {
  return <WelcomeIraPage />
}
